export default "__VITE_ASSET__97H4XSE$__"